import {
    DELETE_NEWS_FAILURE,
    DELETE_NEWS_REQUEST,
    DELETE_NEWS_SUCCESS,
    RESET_DELETE_NEWS_STATE
} from "../actions/delete-news-actions";

const initialState = {
    isDeleted: false,
    isLoading: false,
    error: null,
};

export default function deleteNewsReducer(state = initialState, action) {
    switch (action.type) {
        case DELETE_NEWS_REQUEST:
            return { ...state, isLoading: true, error: null, isDeleted: false };
        case DELETE_NEWS_SUCCESS:
            return { ...state, isLoading: false, isDeleted: true };
        case DELETE_NEWS_FAILURE:
            return { ...state, isLoading: false, error: action.payload, isDeleted: false };
        case RESET_DELETE_NEWS_STATE:
            return initialState;
        default:
            return state;
    }
}